import * as Tone from 'tone';
import { BasePlayer } from "./BasePlayer";
import { getRandomElement } from "@/functions";
export class BackgroundPlayer extends BasePlayer {
    constructor({ path, name, input, config }) {
        super({ path, name, input, config });
        const { samplePool, loopStart, loopEnd } = this.config;
        const url = `./audio/${this.path}/${getRandomElement(samplePool)}.mp3`;
        this.player = new Tone.Player({
            url,
            loop: true,
            loopStart,
            loopEnd,
            autostart: true,
            volume: -Infinity,
        });
    }
    connect(node) {
        return super.connect(node);
    }
}
